import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { MapPin, Sparkles } from 'lucide-react';
// All Florida service locations with coordinates for map markers.
// size: lg = top metro, md = secondary city, sm = local town
const MAJOR_CITIES = [{
  name: 'Miami',
  lat: 25.7617,
  lng: -80.1918,
  size: 'lg'
}, {
  name: 'Orlando',
  lat: 28.5383,
  lng: -81.3792,
  size: 'lg'
}, {
  name: 'Tampa',
  lat: 27.9506,
  lng: -82.4572,
  size: 'lg'
}, {
  name: 'Jacksonville',
  lat: 30.3322,
  lng: -81.6557,
  size: 'lg'
}, {
  name: 'Tallahassee',
  lat: 30.4383,
  lng: -84.2807,
  size: 'md'
}, {
  name: 'Pensacola',
  lat: 30.4213,
  lng: -87.2169,
  size: 'md'
}, {
  name: 'Fort Lauderdale',
  lat: 26.1224,
  lng: -80.1373,
  size: 'md'
}, {
  name: 'Naples',
  lat: 26.142,
  lng: -81.7948,
  size: 'md'
}, {
  name: 'St. Petersburg',
  lat: 27.7676,
  lng: -82.6403,
  size: 'md'
}, {
  name: 'Hialeah',
  lat: 25.8576,
  lng: -80.2781,
  size: 'md'
}, {
  name: 'Cape Coral',
  lat: 26.5629,
  lng: -81.9495,
  size: 'md'
}, {
  name: 'Fort Myers',
  lat: 26.6406,
  lng: -81.8723,
  size: 'md'
}, {
  name: 'West Palm Beach',
  lat: 26.7153,
  lng: -80.0534,
  size: 'md'
}, {
  name: 'Hollywood',
  lat: 26.0112,
  lng: -80.1495,
  size: 'md'
}, {
  name: 'Pembroke Pines',
  lat: 26.0078,
  lng: -80.2962,
  size: 'md'
}, {
  name: 'Lakeland',
  lat: 28.0395,
  lng: -81.9498,
  size: 'md'
}, {
  name: 'Clearwater',
  lat: 27.9659,
  lng: -82.8001,
  size: 'md'
}, {
  name: 'Gainesville',
  lat: 29.6516,
  lng: -82.3248,
  size: 'md'
}, {
  name: 'Key West',
  lat: 24.5551,
  lng: -81.78,
  size: 'sm'
}, {
  name: 'Daytona Beach',
  lat: 29.2108,
  lng: -81.0228,
  size: 'sm'
}, {
  name: 'Sarasota',
  lat: 27.3364,
  lng: -82.5307,
  size: 'sm'
}, {
  name: 'Boca Raton',
  lat: 26.3683,
  lng: -80.1289,
  size: 'sm'
}, {
  name: 'Delray Beach',
  lat: 26.4615,
  lng: -80.0728,
  size: 'sm'
}, {
  name: 'Jupiter',
  lat: 26.9342,
  lng: -80.0942,
  size: 'sm'
}, {
  name: 'Palm Bay',
  lat: 28.0345,
  lng: -80.5887,
  size: 'sm'
}, {
  name: 'Melbourne',
  lat: 28.0836,
  lng: -80.6081,
  size: 'sm'
}, {
  name: 'Doral',
  lat: 25.8195,
  lng: -80.3553,
  size: 'sm'
}, {
  name: 'Weston',
  lat: 26.1004,
  lng: -80.3998,
  size: 'sm'
}, {
  name: 'Winter Haven',
  lat: 28.0222,
  lng: -81.7329,
  size: 'sm'
}, {
  name: 'Altamonte Springs',
  lat: 28.6611,
  lng: -81.3656,
  size: 'sm'
}, {
  name: 'New Smyrna Beach',
  lat: 29.0258,
  lng: -80.927,
  size: 'sm'
}, {
  name: 'Largo',
  lat: 27.9095,
  lng: -82.7873,
  size: 'sm'
}, {
  name: 'Port St. Lucie',
  lat: 27.2939,
  lng: -80.3503,
  size: 'sm'
}, {
  name: 'Palm Coast',
  lat: 29.5847,
  lng: -81.2078,
  size: 'sm'
}, {
  name: 'Bradenton',
  lat: 27.4989,
  lng: -82.5748,
  size: 'sm'
}, {
  name: 'Kissimmee',
  lat: 28.2919,
  lng: -81.4076,
  size: 'sm'
}, {
  name: 'Venice',
  lat: 27.0998,
  lng: -82.4543,
  size: 'sm'
}, {
  name: 'Bonita Springs',
  lat: 26.3398,
  lng: -81.7787,
  size: 'sm'
}, {
  name: 'Coral Springs',
  lat: 26.2712,
  lng: -80.2706,
  size: 'sm'
}, {
  name: 'Winter Park',
  lat: 28.6,
  lng: -81.3392,
  size: 'sm'
}, {
  name: 'Deerfield Beach',
  lat: 26.3184,
  lng: -80.0998,
  size: 'sm'
}, {
  name: 'Destin',
  lat: 30.3935,
  lng: -86.4958,
  size: 'sm'
}, {
  name: 'Panama City',
  lat: 30.1588,
  lng: -85.6602,
  size: 'sm'
}, {
  name: 'Riverview',
  lat: 27.8661,
  lng: -82.3265,
  size: 'sm'
}, {
  name: 'Pompano Beach',
  lat: 26.2378,
  lng: -80.1248,
  size: 'sm'
}, {
  name: 'Homestead',
  lat: 25.4687,
  lng: -80.4776,
  size: 'sm'
}, {
  name: 'North Port',
  lat: 27.0442,
  lng: -82.236,
  size: 'sm'
}, {
  name: 'Lehigh Acres',
  lat: 26.6204,
  lng: -81.6248,
  size: 'sm'
}, {
  name: 'Miramar',
  lat: 25.9873,
  lng: -80.2323,
  size: 'sm'
}, {
  name: 'Aventura',
  lat: 25.9565,
  lng: -80.139,
  size: 'sm'
}, {
  name: 'Davie',
  lat: 26.0628,
  lng: -80.2331,
  size: 'sm'
}, {
  name: 'Margate',
  lat: 26.2445,
  lng: -80.2065,
  size: 'sm'
}, {
  name: 'Coconut Creek',
  lat: 26.2517,
  lng: -80.1789,
  size: 'sm'
}, {
  name: 'Lake Worth',
  lat: 26.6157,
  lng: -80.0684,
  size: 'sm'
}, {
  name: 'Wellington',
  lat: 26.6618,
  lng: -80.2417,
  size: 'sm'
}, {
  name: 'Ocala',
  lat: 29.1872,
  lng: -82.1401,
  size: 'sm'
}, {
  name: 'St. Augustine',
  lat: 29.9012,
  lng: -81.3124,
  size: 'sm'
}, {
  name: 'Apopka',
  lat: 28.6934,
  lng: -81.5322,
  size: 'sm'
}, {
  name: 'Vero Beach',
  lat: 27.6386,
  lng: -80.3973,
  size: 'sm'
}, {
  name: 'Sanford',
  lat: 28.8003,
  lng: -81.2731,
  size: 'sm'
}, {
  name: 'Wesley Chapel',
  lat: 28.2393,
  lng: -82.327,
  size: 'sm'
}];
const ALL_CITIES = ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'Sarasota', 'Naples', 'West Palm Beach', 'Boca Raton', 'St. Petersburg', 'Delray Beach', 'Jupiter', 'Palm Bay', 'Melbourne', 'Doral', 'Weston', 'Winter Haven', 'Altamonte Springs', 'New Smyrna Beach', 'Largo', 'Clearwater', 'Tallahassee', 'Pensacola', 'Gainesville', 'Lakeland', 'Fort Myers', 'Port St. Lucie', 'Palm Coast', 'Daytona Beach', 'Bradenton', 'Kissimmee', 'Venice', 'Hollywood', 'Bonita Springs', 'Coral Springs', 'Winter Park', 'Deerfield Beach', 'Destin', 'Panama City', 'Riverview', 'Pompano Beach', 'Homestead', 'Cape Coral', 'North Port', 'Lehigh Acres', 'Miramar', 'Aventura', 'Hialeah', 'Davie', 'Margate', 'Pembroke Pines', 'Coconut Creek', 'Lake Worth', 'Wellington', 'Ocala', 'St. Augustine', 'Apopka', 'Vero Beach', 'Sanford', 'Key West', 'Wesley Chapel'];
export function CoverageMap() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].coverage;
  const mapRef = useRef<HTMLDivElement>(null);
  const leafletMapRef = useRef<any>(null);
  useEffect(() => {
    let mounted = true;
    let observer: IntersectionObserver | null = null;
    async function initMap() {
      // Dynamic import of leaflet (avoids SSR issues and only loads when needed)
      const L = (await import('leaflet')).default;
      // Inject leaflet CSS
      if (!document.getElementById('leaflet-css')) {
        const link = document.createElement('link');
        link.id = 'leaflet-css';
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.appendChild(link);
      }
      if (!mounted || !mapRef.current || leafletMapRef.current) return;
      // Initialize map centered on Florida
      const map = L.map(mapRef.current, {
        center: [27.8, -83.3],
        zoom: 6,
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: true,
        attributionControl: false
      });
      // Add modern dark tile layer (CartoDB Dark Matter)
      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png', {
        maxZoom: 12,
        minZoom: 5
      }).addTo(map);
      // Add labels layer on top
      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}{r}.png', {
        maxZoom: 12,
        minZoom: 5
      }).addTo(map);
      // Custom red pulse marker icon — labels appear next to lg/md cities
      const createIcon = (size: 'lg' | 'md' | 'sm', name: string) => {
        const dim = size === 'lg' ? 22 : size === 'md' ? 16 : 10;
        const border = size === 'sm' ? 2 : 3;
        const showLabel = size !== 'sm';
        const labelHtml = showLabel ? '<div style="position:absolute;left:50%;top:' + (dim + 4) + 'px;transform:translateX(-50%);background:rgba(0,0,0,0.78);color:white;padding:2px 7px;border-radius:5px;font-size:' + (size === 'lg' ? '11px' : '10px') + ';font-weight:700;white-space:nowrap;letter-spacing:0.3px;border:1px solid rgba(255,255,255,0.15);pointer-events:none;">' + name + '</div>' : '';
        const pulseHtml = size !== 'sm' ? '<div style="position:absolute;inset:0;background:#D32F2F;border-radius:50%;animation:mf-pulse 2s infinite;opacity:0.6;"></div>' : '';
        return L.divIcon({
          className: 'mf-marker',
          html: '<div style="position:relative;width:' + dim + 'px;height:' + dim + 'px;">' + '<div style="position:absolute;inset:0;background:#D32F2F;border-radius:50%;border:' + border + 'px solid white;box-shadow:0 0 0 2px rgba(211,47,47,0.5),0 4px 10px rgba(0,0,0,0.4);z-index:2;"></div>' + pulseHtml + labelHtml + '</div>',
          iconSize: [dim, dim],
          iconAnchor: [dim / 2, dim / 2]
        });
      };
      // Inject pulse animation keyframes
      if (!document.getElementById('mf-marker-styles')) {
        const style = document.createElement('style');
        style.id = 'mf-marker-styles';
        style.textContent = `
          @keyframes mf-pulse {
            0% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(2.2); opacity: 0; }
            100% { transform: scale(1); opacity: 0; }
          }
          .leaflet-container { background: #0a0a0a !important; font-family: inherit; }
          .leaflet-popup-content-wrapper { 
            background: #212121; 
            color: white; 
            border-radius: 12px;
            border: 1px solid rgba(211,47,47,0.5);
          }
          .leaflet-popup-tip { background: #212121; }
          .leaflet-popup-content { 
            margin: 12px 16px; 
            font-weight: 600; 
            font-size: 14px;
          }
          .leaflet-popup-close-button { color: white !important; }
        `;
        document.head.appendChild(style);
      }
      // Render small pins first so larger labeled pins draw on top
      const ordered = [...MAJOR_CITIES].sort((a, b) => {
        const order: Record<string, number> = {
          sm: 0,
          md: 1,
          lg: 2
        };
        return order[a.size] - order[b.size];
      });
      ordered.forEach(city => {
        const marker = L.marker([city.lat, city.lng], {
          icon: createIcon(city.size as any, city.name)
        }).addTo(map);
        marker.bindPopup('<strong style="color:#FFC107;">' + city.name + '</strong><br/><span style="color:#9CA3AF;font-size:12px;">Active Coverage</span>');
      });
      leafletMapRef.current = map;
    }
    if (mapRef.current && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) {
          initMap();
          observer?.disconnect();
        }
      }, {
        rootMargin: '300px'
      });
      observer.observe(mapRef.current);
    } else {
      initMap();
    }
    return () => {
      mounted = false;
      observer?.disconnect();
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
      }
    };
  }, []);
  return <section className="py-24 bg-mf-black text-white relative overflow-hidden" data-id="element-98">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-99">
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-mf-red/10 blur-[120px] rounded-full" data-id="element-100"></div>
        <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-mf-yellow/5 blur-[120px] rounded-full" data-id="element-101"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-102">
        <div className="text-center mb-16" data-id="element-103">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="text-4xl md:text-6xl font-condensed font-black uppercase tracking-tight mb-6" data-id="element-104">
            {text.title}
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="h-1.5 bg-mf-red mx-auto rounded-full mb-6" data-id="element-105"></motion.div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-106">
            {text.subtitle}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch" data-id="element-107">
          {/* Modern Leaflet Map */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 20
        }} className="lg:col-span-7 relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl" style={{
          minHeight: '500px'
        }} data-id="element-108">
            <div ref={mapRef} className="w-full h-full absolute inset-0 z-0" data-id="element-109"></div>

            {/* Floating Stat Card */}
            <div className="absolute top-4 left-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4 z-[400] shadow-xl" data-id="element-110">
              <div className="flex items-center gap-3" data-id="element-111">
                <div className="w-10 h-10 bg-mf-red rounded-xl flex items-center justify-center" data-id="element-112">
                  <Sparkles size={20} className="text-white" data-id="element-113" />
                </div>
                <div data-id="element-114">
                  <div className="text-2xl font-condensed font-black text-white" data-id="element-115">
                    60+
                  </div>
                  <div className="text-xs text-gray-300 uppercase tracking-wider" data-id="element-116">
                    Cities Covered
                  </div>
                </div>
              </div>
            </div>

            {/* Map Hint */}
            <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-md border border-white/10 rounded-full px-4 py-2 z-[400]" data-id="element-117">
              <p className="text-xs text-gray-300 font-medium flex items-center" data-id="element-118">
                <MapPin size={12} className="mr-2 text-mf-red" data-id="element-119" />
                {text.mapHint}
              </p>
            </div>
          </motion.div>

          {/* Cities List */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="lg:col-span-5" data-id="element-120">
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 h-full" data-id="element-121">
              <h3 className="text-xl font-condensed font-black text-white uppercase tracking-wider mb-6 flex items-center" data-id="element-122">
                <MapPin className="mr-2 text-mf-red" size={20} data-id="element-123" />
                Service Areas
              </h3>

              <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 max-h-[420px] overflow-y-auto pr-2 scrollbar-thin" data-id="element-124">
                {ALL_CITIES.map((city, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.01
              }} className="flex items-center text-sm text-gray-300 font-medium hover:text-white hover:translate-x-1 transition-all cursor-default" data-id="element-125">
                    <div className="w-1.5 h-1.5 bg-mf-red rounded-full mr-2.5 flex-shrink-0" data-id="element-126"></div>
                    <span className="truncate" data-id="element-127">{city}</span>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}